import { AppRouteProps } from "@bsm/component";
import { DataContainer } from "./containers/DataContainer";
import { DataImportRoutes } from "./view/import/DataImportRoutes";
import { DataExportRoutes } from "./view/export/DataExportRoutes";

export const DataExports: Array<AppRouteProps> = [
    {
        title: "Harea.Data.Title",
        path: "data",
        element: <DataContainer />,
        children: [...DataImportRoutes, ...DataExportRoutes],
    },
];
